/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  routes,
  base: '/',
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    let position = {x: 0, y: 0}
    if (savedPosition) {
      position = savedPosition
    }
    return position
  }
})

router.beforeResolve((to, from, next) => {
  next()
})

export default router
